import React from "react";
import DiabetesType from "../../../../../Diathrive/src/containers/DiabetesType";

const DiabetesTypeSelection = (props) => <DiabetesType {...props} />;

export default DiabetesTypeSelection;
